import ArchiveIssueButtonItem from './button-item';
import ArchiveIssueView from './main';
import messages from './messages';

export const archiveIssueLabel = messages.archive;
export default ArchiveIssueView;
export { ArchiveIssueButtonItem };
